﻿export default class MarketingConsents {
    constructor() {
        this.dom = {
            $: window.$,
            language: $('html').attr('lang'),
            $mainCheckInput: $('.form-agree-main-check input[type="checkbox"]'),
            $masterAgreeInput: $('.form-agree-master-check:visible input[type="checkbox"]'),
            $master2AgreeInput: $('.form-agree-master2-check input[type="checkbox"]')
        };

        this.init();
    }

    init() {
        let thisDom = this.dom;

        switch (thisDom.language) {
            case 'pl':
                // code block
                this.agreeCheckAllInWrapper(this.dom.$mainCheckInput, '.form-agree-main-check:visible', true);
                this.agreeCheckAllInWrapper(this.dom.$masterAgreeInput, '.form-agree-master', true);
                break;
            case 'ro':
                // code block
                this.agreeCheckAllInWrapper(this.dom.$mainCheckInput, '.form-agree-main-check', true);
                this.agreeCheckAllInWrapper(this.dom.$masterAgreeInput, '.form-agree-master', true);
                this.agreeCheckAllInWrapper(this.dom.$master2AgreeInput, '.form-agree-master2', true);
                break;
            default:
            // code block
        }
    }

    //Handle Marketing checklist logic
    agreeCheckAllInWrapper($mainInput, parent, trackChilden) {
        let thisDom = this.dom;
        let findText = (window.location.pathname.substr(1) == "abandoned-basket" ? 'input[type="checkbox"]:not([data-val-required="true"]:checked)' : 'input[type="checkbox"]');

        $.each($mainInput, function (index, inputObj) {
            let $inputsWrapper = $(inputObj).parents(parent);
            if (thisDom.language == 'pl' && parent == ".form-agree-master") findText = ".form-agree-single:visible " + findText;

            let $inputs = $inputsWrapper.next().find(findText);

            $(inputObj).on('change', ((e) => {
                if (thisDom.language == 'ro' && $(inputObj).is(':checked')) $(inputObj).closest('.form-agree-main-check').find('.accordion-trigger:not(.accordion-open)').trigger('click');

                $inputs.prop('checked', $(inputObj).is(':checked'));

                //revalidate checkboxes
                $.each($inputs, function (idx, chkObj) {
                    if ($(chkObj).hasClass('form-error')) $(chkObj).valid();
                });

            }));
            if (trackChilden) {
                $inputs.on('change', (() => {
                    $(inputObj).prop('checked', $inputs.filter(':not(:checked)').length == 0);
                }));
            }

            $inputs.filter(':checked:not(:disabled)').trigger("change");
        });
    }
}

document.addEventListener('DOMContentLoaded', () => new MarketingConsents());